export default class YAML {
    /**
     * Decodes a YAML string.
     * Purpose built to handle only Quaver chart files, should not be used for actual YAML parsing.
     * @param data YAML string
     * @return
     */
    static decode(data) {
        let out = {};
        let bufflines = data.split("\n");
        // Advanced File Basic
        const ARRAY_TOKEN = ['- ', '  '];
        let buckets = [out];
        let bucket_keys = [null];
        let bucket_depths = [0];
        let bucket_depth = 0;
        let bucket_last_depth = 0;
        let line;
        let key;
        let val;
        let keyToken;
        let stackBucket;
        let stackBucketKey;
        for (let l = 0; l < bufflines.length; l++) {
            line = bufflines[l];
            bucket_depth = 0;
            let splitIndex = line.indexOf(":");
            let startArrayItem = false;
            key = line.substring(0, splitIndex);
            val = this.parseValue(line.substring(splitIndex + 1).trim());
            keyToken = key.substring(0, 2);
            // Empty Line
            if (line.length == 0 || splitIndex < 0)
                continue;
            // Bucket Depth
            if (ARRAY_TOKEN.indexOf(keyToken) >= 0) {
                startArrayItem || (startArrayItem = keyToken.indexOf("-") >= 0);
                while (true) {
                    key = key.substring(2);
                    keyToken = key.substring(0, 2);
                    bucket_depth++;
                    startArrayItem || (startArrayItem = keyToken.indexOf("-") >= 0);
                    if (ARRAY_TOKEN.indexOf(keyToken) < 0)
                        break;
                }
            }
            // New Array Item at the same depth.
            if (startArrayItem && bucket_depth == bucket_last_depth) {
                stackBucket = buckets.pop();
                stackBucketKey = bucket_keys.pop();
                bucket_depths.pop();
                if (stackBucketKey == null)
                    buckets[buckets.length - 1].push(stackBucket);
            }
            // Depth changed, close up open buckets.
            if (bucket_depth < bucket_last_depth) {
                let returnDepth = bucket_depths.pop();
                while (returnDepth >= bucket_depth) {
                    stackBucket = buckets.pop();
                    stackBucketKey = bucket_keys.pop();
                    // Either Object or Array, no key means array.
                    if (stackBucketKey == null)
                        buckets[buckets.length - 1].push(stackBucket);
                    else
                        buckets[buckets.length - 1][stackBucketKey] = stackBucket;
                    // Don't empty the buffer, the main collection resides at 0.
                    if (bucket_depths.length <= 1)
                        break;
                    returnDepth = bucket_depths.pop();
                }
            }
            // Start New Object
            if (startArrayItem) {
                buckets.push({});
                bucket_keys.push(null);
                bucket_depths.push(bucket_depth);
            }
            // New Array
            if (val == null) {
                buckets.push([]);
                bucket_keys.push(key);
                bucket_depths.push(bucket_depth);
            }
            else {
                buckets[buckets.length - 1][key] = val;
            }
            // Save Last State
            bucket_last_depth = bucket_depth;
        }
        // Collapse Remaining Buckets
        while (buckets.length > 1) {
            stackBucket = buckets.pop();
            stackBucketKey = bucket_keys.pop();
            // Either Object or Array, no key means array.
            if (stackBucketKey == null)
                buckets[buckets.length - 1].push(stackBucket);
            else
                buckets[buckets.length - 1][stackBucketKey] = stackBucket;
        }
        return out;
    }
    static parseValue(val) {
        if (val == "" || val.length == 0)
            return null;
        if (val == "[]")
            return [];
        else if (val == "''")
            return '';
        else if (val.charAt(0) == "'")
            return val.substring(1, val.length - 2);
        // Has quote escape characters, maintains \\ as well.
        else if (val.charAt(0) == '"') {
            if (val.indexOf("\\\\") >= 0)
                return val.substring(1, val.length - 2).replace(/\\\\/gm, "!---slash-replace---!").replace(/\\/gm, "").replace(/!---slash-replace---!/gm, "\\");
            else
                return val.substring(1, val.length - 2).replace(/\\/gm, "");
        }
        return val;
    }
}
